import React, {Component} from 'react';
import facebookIcon from '../resources/social_media_imgs/fbkolor_1.svg';
import instagramIcon from '../resources/social_media_imgs/instakolor.svg';
import twitterIcon from '../resources/social_media_imgs/twitkolor_2.svg';
import {useSpring, animated} from 'react-spring';
import {Button} from 'react-bootstrap';

const isMobile = window.innerWidth <= 500;
const scrollLim = isMobile ? 110 : 300;

let iconStyleSide = {
    margin: isMobile ? '0.2rem' : '0rem'
};
let iconStyleBottom = {
    margin: isMobile ? '0.4rem' : '0.8rem'
};

let styleBottom = {
    backgroundColor: "#000000BF",
    color: "white",
    fontWeight: "bold",
    fontSize: isMobile ? 13 : 16,
    position: "fixed",
    left: "0",
    bottom: "0",
    height: isMobile ? "8%" : "8%",
    width: "100vw",
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    // alignContent: 'flex-end'
};

let styleSide = {
    backgroundColor: "#000000BF",
    color: "white",
    fontWeight: "bold",
    fontSize: isMobile ? 13 : 16,
    position: "fixed",
    left: "0",
    bottom: isMobile ? "40%" : "60%",
    height: isMobile ? "28%" : "18%",
    width: isMobile ? "12%" : "4%",
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderTopRightRadius: '1.2rem',
    borderBottomRightRadius: '1.2rem'
};

let phantom = {
    display: 'block',
    height: '6vh',
    width: '100vw',
};


class FooterInternal extends Component {

    state = {
        style: styleSide,
        iconStyle: iconStyleSide,
        stateNo: 0
    };

    listenScrollEvent = e => {
        if (window.scrollY > scrollLim) {
            this.setState({style: styleBottom, iconStyle: iconStyleBottom, stateNo: 1})
        }
        else {
            this.setState({style: styleSide, iconStyle: iconStyleSide, stateNo: 0});
        }
    };

    componentDidMount() {
        window.addEventListener('scroll', this.listenScrollEvent)
    }

    render() {
        const socialIconsSize = '30rem';
        return (
            <div>
                <div style={phantom}/>
                <div style={this.state.style}>
                    <a href="https://www.facebook.com/dzikiezwierzetaprzemysl/">
                        <img style={this.state.iconStyle} src={facebookIcon} width={socialIconsSize}
                             height={socialIconsSize}/>
                    </a>
                    <a href="https://www.instagram.com/osrodek.rehabilitacji/?hl=pl">
                        <img style={this.state.iconStyle} src={instagramIcon} width={socialIconsSize}
                             height={socialIconsSize}/>
                    </a>
                    <a href="https://twitter.com/OsrodekC">
                        <img style={this.state.iconStyle} src={twitterIcon} width={socialIconsSize}
                             height={socialIconsSize}/>
                    </a>
                </div>
            </div>
        );
    }
}

function Footer() {
    const animProps = useSpring({opacity: 1, from: {opacity: 0}});
    return (
        <animated.div style={animProps}>
            <FooterInternal/>
        </animated.div>
    )
}

export default Footer;